@let _qaaPrefix = qaaPrefix();
<div>
  <span>&copy;{{ year }} Firm Software LLC</span>
  <span style="margin-left: 10px; margin-right: 10px">|</span>
  <span
    ><a
      href="mailto:support@myfirm360.com"
      [attr.data-qaa]="_qaaPrefix + '-support-email-link'"
      >support&#64;myfirm360.com</a
    ></span
  >
  <span style="margin-left: 10px; margin-right: 10px">|</span>
  @if (
    featureService.isFeatureEnabled(Feature.PREMIUM_SUPPORT, currentAccount)
  ) {
    <span [attr.data-qaa]="_qaaPrefix + '-support-phone'">888.960.0510</span>
  }
  @if (
    featureService.isFeatureEnabled(Feature.PREMIUM_SUPPORT, currentAccount)
  ) {
    <span style="margin-left: 10px; margin-right: 10px">|</span>
  }
  <span
    ><a
      target="_blank"
      href="https://firm360.zendesk.com/hc/en-us/"
      [attr.data-qaa]="_qaaPrefix + '-help-center-link'"
      >Help Center</a
    ></span
  >
</div>
